module.exports = __webpack_public_path__ + "img/choice_port1.1493a567.png";